export const CONSTANTS_DEPLOYMENT_STATUS = {
  failed: 'Failed',
  success: 'Success',
};
